import { render } from "./CreditsConsoleLog.vue?vue&type=template&id=b24d7468"
import script from "./CreditsConsoleLog.vue?vue&type=script&lang=js"
export * from "./CreditsConsoleLog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__